<template>
    <div>
        <div class="container" style="min-width: 900px">
            <el-form :inline="true" ref="userForm" :model="check" :rules="rules" class="demo-form-inline">
                <el-form-item label="查询订单号是否存在" prop="orderId">
                    <el-input v-model="check.orderId" placeholder="order" style="width: 260px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="offline('userForm')">查 询</el-button>
                </el-form-item>
            </el-form>

            <el-form :inline="true" ref="refundOrderParams" :model="refundParamsList" :rules="rules"
                class="demo-form-inline">
                <el-form-item label="指定订单号退款" prop="tradeNo">
                    <el-input v-model="refundParamsList.tradeNo" placeholder="order" style="width: 260px;"></el-input>
                </el-form-item>
                <el-form-item label="退款金额" prop="receiptAmount">
                    <el-input v-model="refundParamsList.receiptAmount" placeholder="amount"
                        style="width: 260px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="refund('refundOrderParams')">操 作</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { checkOrderNoExist } from '../../../api/pay.js'
import { refundOrder } from '../../../api/pay.js'
export default {
    name: 'AlipayOperation',
    data: function () {
        return {
            result: null,
            refundParamsList: {
                tradeNo: "", //订单号
                receiptAmount: 0, //退款金额
            },
            check: {
                orderId: '',
            },
            rules: {
                userId: [
                    { required: true, message: '订单号不能为空', trigger: 'blur' },
                ],
                tradeNo: [
                    { required: true, message: '订单号不能为空', trigger: 'blur' },
                ],
                receiptAmount: [
                    { required: true, message: '退款金额不能为空', trigger: 'blur' },
                ],
            },
        }

    },
    mounted(e) {
        this.refundParamsList.tradeNo = this.$route.query.refundOrderNo;
        this.refundParamsList.receiptAmount = this.$route.query.price;
    },
    methods: {
        refund(refundOrderParams) {
            this.$confirm('是否确定退款?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$refs[refundOrderParams].validate((valid) => {
                    if (valid) {
                        let params = { 'tradeNo': this.refundParamsList.tradeNo, 'receiptAmount': this.refundParamsList.receiptAmount }
                        refundOrder(params).then(res => {
                            if (res.data.code == 200) {
                                alert("退款成功")
                            } else {
                                alert("退款失败,请检查参数信息，或该订单已退款。")
                            }
                            console.log(res);
                        })
                    }
                })
            }).catch(() => { })


        },
        offline(userForm) {
            this.$refs[userForm].validate((valid) => {
                if (valid) {
                    let params = { 'tradeNo': this.check.orderId }
                    checkOrderNoExist(params).then(res => {
                        if (res.status == 200) {
                            if (res.data == true) {
                                alert("查询结果为:存在")
                            } else {
                                alert("查询结果为:不存在")
                            }
                            //   this.$message.success(res.data.message)
                        } else {
                            //  this.$message.error(res.data.message)
                        }
                    })
                }
            })
        }
    }
}

</script>